
import { Component, Model, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import { RfidService } from "@/views/rfid/api/rfid-service";

@Component({
  name: 'SupplierOrRepairFactoryDialog'
})
export default class extends Vue {
  @Prop() private type: string;
  @PropSync('visible') private dialogVisible: boolean;
  @Prop() private value: any;

  private loading = false;
  private currentValue: any = null;
  private options: any[] = [];

  get isSupplier() {
    return this.type === 'supplier';
  }

  get title() {
    return "选择" + this.label;
  }

  get label() {
    return this.isSupplier ? "供应商" : "维修工厂"
  }

  @Watch('value', { immediate: true })
  onValueChange(v) {
    this.currentValue = v?.value;
  }

  async mounted() {
    await this.getOptions();
  }

  async getOptions() {
    const action = this.isSupplier ? RfidService.querySupplier : RfidService.queryRepairFactory;
    this.loading = true;
    try {
      this.options = await action();
    } finally {
      this.loading = false;
    }
  }

  onCancel() {
    this.dialogVisible = false;
  }

  onOk() {
    if (!this.currentValue) {
      this.$message.error('请选择' + this.label);
      return;
    }

    const option = this.options.find((item) => item.value === this.currentValue)
    this.$emit('input', { ...option });
    this.dialogVisible = false;
  }
}
